module.exports = __webpack_public_path__ + "static/media/protocol_select.e4f9c8a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/protocol_select.png
// module id = 1848
// module chunks = 0 1